<template>
    <v-chip
        v-if="(text !== null && text !== undefined && text !== '') || showEvenTextIsNull"
        :class="color ? 'ma-1 white--text' : 'ma-1'"
        small
        :large="large"
        :outlined="outlined"
        :label="label"
        :color="color"
        @click="press"
        :disabled="disabled"
    >
        <strong>{{ text }}</strong>
        <v-icon
            v-if="icon && !readonly"
            right
            :color="iconColor"
            small
        >
            {{ icon }}
        </v-icon>
    </v-chip>
</template>

<script>
export default {
    name: 'WChip',
    props: {
        color: String,
        text: [String, Number, Object],
        outlined: Boolean,
        large: Boolean,
        label: Boolean,
        disabled: Boolean,
        icon: String,
        iconColor: String,
        showEvenTextIsNull: Boolean,
        readonly: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            if (!props.readonly) {
                emit('press');
            }
        }
        
        return {
            press
        }
    }
}
</script>

<style scoped>

</style>